import { useGetCurrentClientLocationMutation } from './GetCurrentClientLocationMutation.generated';

const useCurrentClientLocation = () => {
  const [getCurrentClientLocation] = useGetCurrentClientLocationMutation();
  return { getCurrentClientLocation };
};

export default useCurrentClientLocation;
